(function () {
  if (window.__rabanoSetPriceInit) return;
  window.__rabanoSetPriceInit = true;

  // Zahl aus einem Preistext lesen, egal ob "27,99€", "€27.99" oder "1.234,50 EUR"
  function numInfo(text) {
    if (!text) return null;
    var s = String(text).replace(/\u00a0/g, ' ');
    var m = s.match(/\d[\d.,\s]*\d|\d/);
    if (!m) return null;
    var raw = m[0];
    var clean = raw.replace(/\s/g, '');
    var sep = Math.max(clean.lastIndexOf(','), clean.lastIndexOf('.'));
    var dec = null;
    if (sep > -1) {
      var tail = clean.length - sep - 1;
      if (tail === 1 || tail === 2) dec = clean.charAt(sep);
    }
    var intPart, frac = '0';
    if (dec) {
      intPart = clean.slice(0, sep).replace(/[.,]/g, '');
      frac = clean.slice(sep + 1);
    } else {
      intPart = clean.replace(/[.,]/g, '');
    }
    var value = parseFloat(intPart + '.' + frac);
    if (isNaN(value)) return null;
    return { value: value, raw: raw, index: m.index, dec: dec || ',' };
  }

  // neue Zahl in die Schreibweise des Originaltexts einsetzen (Währungszeichen bleibt)
  // abgerundet auf volle Cent - genau wie Liquids Ganzzahl-Division, damit
  // 27,99 / 4 = 6,99 ergibt und nicht aufgerundet 7,00
  function render(sample, info, value) {
    var p = (Math.floor(value * 100) / 100).toFixed(2).split('.');
    return (sample.slice(0, info.index) + p[0] + info.dec + p[1] + sample.slice(info.index + info.raw.length)).trim();
  }

  function updateBlock(block) {
    var units = parseInt(block.getAttribute('data-set-units'), 10);
    if (!units || units < 2) return;
    var label = block.getAttribute('data-unit-label') || '';
    var nowEl = block.querySelector('.custom-price-block__now');
    var badge = block.querySelector('.custom-price-block__badge');
    if (!nowEl || !badge) return;

    var nowText = nowEl.textContent.trim();
    var info = numInfo(nowText);
    if (!info || !info.value) return;

    var perText = 'Nur ' + render(nowText, info, info.value / units) + ' /' + label;
    if (badge.textContent.trim() !== perText) badge.textContent = perText;

    var cmpEl = block.querySelector('.custom-price-block__compare s');
    var savEl = block.querySelector('.custom-price-block__saving');
    if (cmpEl && savEl) {
      var cmp = numInfo(cmpEl.textContent.trim());
      if (cmp && cmp.value > info.value) {
        var sav = String(Math.round((cmp.value - info.value) / cmp.value * 100));
        if (savEl.textContent.trim() !== sav) savEl.textContent = sav;
      }
    }
  }

  // requestAnimationFrame muss an window gebunden aufgerufen werden,
  // sonst wirft Chrome "Illegal invocation"
  function schedule(fn) {
    if (window.requestAnimationFrame) return window.requestAnimationFrame(fn);
    return window.setTimeout(fn, 16);
  }

  var pending = false;
  function update() {
    if (pending) return;
    pending = true;
    schedule(function () {
      pending = false;
      var blocks = document.querySelectorAll('.custom-price-block--set[data-set-units]');
      for (var i = 0; i < blocks.length; i++) updateBlock(blocks[i]);
    });
  }

  update();
  document.addEventListener('DOMContentLoaded', update);
  ['variant:change', 'variantChange', 'change', 'cart:refresh'].forEach(function (ev) {
    document.addEventListener(ev, update, true);
  });
  if (window.MutationObserver) {
    var root = document.querySelector('main') || document.body || document.documentElement;
    new MutationObserver(update).observe(root, { subtree: true, childList: true, characterData: true });
  }
})();
